export default __webpack_public_path__ + "static/media/tk.1e38ee6c.png";